<template>
  <div v-if="loading">Loading...</div>
  <div v-else>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="appointments"
      :items-per-page="-1"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      item-key="appointmentId"
      class="elevation-1"
      :show-select="false"
    >
      <template v-slot:item.name="{ item }">
        <router-link
          class="font-weight-bold text-decoration-none"
          :to="'student/' + item.studentId"
        >
          <v-avatar size="30">
            <img :src="item.profilePicture" :alt="item.name" />
          </v-avatar>
          {{ item.name }}
        </router-link>
      </template>
      <template v-slot:item.start="{ item }">
        {{ $moment(item.start).format("LLL") }}
      </template>
      <template v-slot:item.end="{ item }">
        {{ $moment(item.end).format("LLL") }}
      </template>
      <template v-slot:item.status="{ item }">
        <div class="d-flex align-center flex-wrap" style="gap: 8px;">
          <div
            v-if="userType === 'student' && item.status === 'Finished' && !item.hasStudentSignature"
            class="list-sign-cta signature-required-blink"
            @click="showDialog({ event: item })"
          >
            <v-icon x-small>mdi-draw</v-icon>
            <span>Sign & rate</span>
          </div>
          <v-btn
            :color="getColor(item.status)"
            dark
            small
            rounded
            :outlined="false"
            :depressed="false"
            @click="showDialog({ event: item })"
          >
            {{ item.status }}
          </v-btn>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  data () {
    return {
      sortBy: 'status',
      sortDesc: true,
      selected: [],
      userType: localStorage.getItem('userType')
    }
  },
  props: {
    loading: { type: Boolean, required: true },
    headers: { type: Array, required: true },
    appointments: { type: Array, required: true },
    getColor: { type: Function, required: true },
    showDialog: { type: Function, required: true }
  }
}
</script>

<style scoped>
.list-sign-cta {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 6px;
  background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%);
  color: #fff;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  user-select: none;
  box-shadow: 0 1px 4px rgba(245, 124, 0, 0.3);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.list-sign-cta:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(245, 124, 0, 0.4);
}
.signature-required-blink {
  animation: signature-blink 1.5s ease-in-out infinite;
}
@keyframes signature-blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.88; }
}
</style>
